<div class="card mb-3">
    <div class="card-header d-flex flex-row justify-content-between">
        <h2 class="card-title mb-0">Promotion Log</h2>
    </div>
    <div class="p-3">
        <div class="d-flex flex-row gap-3 align-items-end mb-3">
            <div>
                <label for="name" class="form-label">Date From</label>
                <input type="datetime-local" class="form-control form-contrl-lg" [(ngModel)]="data.date_from" />
            </div>
            <div>
                <label for="name" class="form-label">Date To</label>
                <input type="datetime-local" class="form-control form-contrl-lg" [(ngModel)]="data.date_to" />
            </div>
            <div>
                <label for="name" class="form-label">Player Code</label>
                <input type="text" class="form-control form-contrl-lg" [(ngModel)]="data.code" />
            </div>
            <div>
                <label for="name" class="form-label">Player Mobile</label>
                <input type="text" class="form-control form-contrl-lg" [(ngModel)]="data.mobile"
                    placeholder="Include Country Code" />
            </div>
            <div>
                <label for="name" class="form-label">Match</label>
                <select class="form-select" [(ngModel)]="data.match">
                    <option value="exact">Exact</option>
                    <option value="approx">Approximate</option>
                </select>
            </div>

            <button class="btn btn-primary" (click)="filter()">Filter</button>
        </div>
    </div>
</div>
<div class="card">
    <div class="card-body p-0">

        <ng-container *ngIf="!load && items.length == 0">
            <h3 class="mb-0 px-2">No Data Available</h3>
        </ng-container>

        <ng-container *ngIf="load">
            <div class="d-flex flex-row align-items-center justify-content-center p-2">
                <div class="loader"></div>
            </div>
        </ng-container>

        <ng-container *ngIf="!load && items.length > 0">
            <div class="table-responsive promotion-log-scroll" tabindex="0"
                aria-label="Promotion log table. Scroll horizontally to view all columns.">
            <table class="table table-sm mb-0 table-striped promotion-log-table">
                <thead>
                    <tr>
                        <th>Player</th>
                        <th>Mobile</th>
                        <th>Promotion</th>
                        <th class="border-start bg-primary text-light text-end">Balance Before</th>
                        <th class="border-start bg-warning text-dark text-end">Bonus</th>
                        <th class="border-start bg-primary text-light text-end">Balance After Bonus</th>
                        <th>Calculation Type</th>
                        <th class="border-start text-end">Minimum T/R</th>
                        <th class="border-start text-end">Minimum Withdrawal</th>
                        <th class="border-start">Status</th>
                        <th>Create On</th>
                        <th>End On</th>
                        <th>Action</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let item of items">
                        <td>{{item.code}}</td>
                        <td>{{item.mobile}}</td>
                        <td>{{item.promotion_title}}</td>
                        <td class="border-start bg-primary text-light text-end">{{item.balance_before}}</td>
                        <td class="border-start bg-warning text-dark text-end">{{item.free_credit}}</td>
                        <td class="border-start bg-primary text-light text-end">{{item.balance_after}}</td>
                        <td class="border-start">{{item.withdraw_type}}</td>
                        <td class="border-start text-end">{{item.min_rolling}}</td>
                        <td class="border-start text-end">{{item.minimum_withdraw}}</td>
                        <td class="border-start">{{statusUpdate(item.status)}}</td>
                        <td>{{item.timestamp | date: "dd-MM-yyyy HH:mm:ss"}}</td>
                        <td>{{item.update_timestamp | date: "dd-MM-yyyy HH:mm:ss"}}</td>
                        <td>
                            <button class="btn btn-sm btn-info" (click)="viewGameLog(item)">Log</button>
                        </td>
                    </tr>
                </tbody>
            </table>
            </div>
        </ng-container>
    </div>
</div>
